import './theme/common.scss';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import getAppConfig from './getAppConfig';
import getWidgetData from './init/data/getWidgetData';
import handlerData from './init/data/handlerData';
import getPlatform from './isomorphic/client';
import getContainer from './init/getContainer';
import globalization from './globalization';
import createTerminology from './common/terminology';
import googleTranslateAutoPage from './common/translate/googleTranslatePlugin/auto-page';
import { getCurrentLanguage } from './globalization/tool';

import util from './common/util';
import plugin from './plugins';
import Router from './common/router';

import './loadFont';

import Track from '@/common/track';



window.sitePrepareData = function() {
    return {
        widget: true
    }
};

function watchBodyRect() {
    let MutationObserver =
        window.MutationObserver ||
        window.WebKitMutationObserver ||
        window.MozMutationObserver;
    if (MutationObserver) {
        const callback = util.debounce(() => {
            // const height = window.parent.window.innerHeight || 700;
            console.log(document.body.getBoundingClientRect());
            window.parent.postMessage(
                JSON.stringify({
                    from: 'chimeSite',
                    event: 'updateBodyRect',
                    data: document.body.getBoundingClientRect()
                }),
                '*'
            );
        }, 1500);
        const config = { attributes: true, childList: true, subtree: true };
        const observer = new MutationObserver(callback);
        observer.observe(document.body, config);
    }
}

Promise.all([
    getWidgetData()
]).then(([{ rawGlobalData, rawPageData, pageResource }]) => {
    var { globalData, pageData } = handlerData({
        rawGlobalData,
        rawPageData,
        theme: pageResource,
        query: util.getQueryField()
    })
    // inject font style and css variable
    const styleDom = document.createElement('style');
    styleDom.innerHTML = pageResource;
    document.head.appendChild(styleDom);
    
    // sitePrepareData method is ready
    window.sitePrepareData = function() {
        return globalData;
    };

    let platform = getPlatform(globalData);
    let lng = getCurrentLanguage.call(platform, globalData);
    let terminology = createTerminology(globalData.terminologyMap);
    let globalizationIns = globalization.create(lng, terminology && (content => terminology.replace(content)));
    window.siteGlobalization = globalizationIns;

    if (globalData.translatorType == 'chime') {
        googleTranslateAutoPage(lng, globalData);
    }

    window.$pinia = createPinia();
    let appConfig = getAppConfig();
    // console.log("appConfig",appConfig);
    var app = createApp(appConfig);
    // global extension of vue
    plugin.install(app, { pinia: window.$pinia, platform, globalData, pageData, globalizationIns });
    window.siteAppVm = app.mount(getContainer(globalData.template));

    Router.multiPageInit(window.siteAppVm, globalData);
    
    window.siteAppVm.$EventBus.$emit('siteTrack', {
        trackType: 'page-change'
    });

    watchBodyRect();

    if (globalData.track?.enableGlobalGa && util.getQueryField('enable-gtm') != '0') {
        Track.prepare();
        Track.resetEventHandler();
    }
    Track.prepareCustomGTM();
});


// eslint-disable-next-line no-undef
console.log('__BUILD_ID__', __BUILD_ID__);
// eslint-disable-next-line no-undef
console.log('__chime env__', process.env.CHIME_ENV);
